'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FileText, List, LogIn, LogOut, Settings, ShieldCheck } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useLocalization } from '../_providers/localization/LocalizationProvider';
import { useAuth } from '../_providers/authentication/AuthProvider';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Separator } from '@/components/ui/separator';
export default function SettingsMenu() {
  const $ = _c(22);
  const pathname = usePathname();
  const {
    isAdmin,
    user,
    loading,
    logout
  } = useAuth();
  const {
    setTheme
  } = useTheme();
  const {
    messages
  } = useLocalization();
  let t0;
  let t1;
  if ($[0] !== setTheme) {
    t0 = () => {
      setTheme("dark");
    };
    t1 = [setTheme];
    $[0] = setTheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" size="icon" className="h-8 w-8 rounded-full"><Settings className="h-4 w-4" /></Button></DropdownMenuTrigger>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LanguageSwitcher />;
    t4 = <Separator className="bg-foreground/30 mt-1" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isAdmin || $[7] !== messages) {
    t5 = isAdmin && <><DropdownMenuItem asChild={true}><Link href="/documents" className="flex items-center gap-2"><FileText className="h-4 w-4" />{messages.settings.documents}</Link></DropdownMenuItem><DropdownMenuItem asChild={true}><Link href="/list" className="flex items-center gap-2"><List className="h-4 w-4" />{messages.settings.list}</Link></DropdownMenuItem><DropdownMenuItem asChild={true}><Link href="/admin" className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" />{messages.settings.admin}</Link></DropdownMenuItem><DropdownMenuSeparator /></>;
    $[6] = isAdmin;
    $[7] = messages;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== loading || $[10] !== messages || $[11] !== pathname || $[12] !== user) {
    t6 = !user && !loading && <><DropdownMenuSeparator /><DropdownMenuItem asChild={true}><Link href={`/login?redirect=${encodeURIComponent(pathname)}`} className="flex items-center gap-2"><LogIn className="h-4 w-4" />{messages.settings.login}</Link></DropdownMenuItem></>;
    $[9] = loading;
    $[10] = messages;
    $[11] = pathname;
    $[12] = user;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== logout || $[15] !== messages || $[16] !== user) {
    t7 = user && <><DropdownMenuSeparator /><DropdownMenuItem onSelect={() => {
        logout();
      }} className="flex items-center gap-2"><LogOut className="h-4 w-4" />{messages.settings.logout}</DropdownMenuItem></>;
    $[14] = logout;
    $[15] = messages;
    $[16] = user;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <DropdownMenu modal={false}>{t2}<DropdownMenuContent align="end" className="w-44">{t3}{t4}{t5}{t6}{t7}</DropdownMenuContent></DropdownMenu>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}